import * as React from "react";
import type {RemixiconComponentType} from "@remixicon/react";

type RemixiconProps = React.ComponentProps<RemixiconComponentType>;

export default function ExternalLinkIcon({size = 15, className, ...props}: RemixiconProps) {
    const maskId = React.useId();
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 15 15"
            fill="none"
            className={className}
            {...props}
        >
            <mask id={maskId} fill="white">
                <path d="M6.25 1.875V3.125H3.125V11.875H11.875V8.75H13.125V12.5C13.125 12.8452 12.8452 13.125 12.5 13.125H2.5C2.15483 13.125 1.875 12.8452 1.875 12.5V2.5C1.875 2.15483 2.15483 1.875 2.5 1.875H6.25ZM10.9911 3.125H8.125V1.875H13.125V6.875H11.875V4.00888L7.5 8.38387L6.61613 7.5L10.9911 3.125Z" />
            </mask>
            <path
                d="M6.25 1.875V3.125H3.125V11.875H11.875V8.75H13.125V12.5C13.125 12.8452 12.8452 13.125 12.5 13.125H2.5C2.15482 13.125 1.875 12.8452 1.875 12.5V2.5C1.875 2.15482 2.15482 1.875 2.5 1.875H6.25ZM10.9911 3.125H8.125V1.875H13.125V6.875H11.875V4.00888L7.5 8.38387L6.61613 7.5L10.9911 3.125Z"
                strokeWidth="4"
                stroke="#949BA8"
                mask={`url(#${maskId})`}
            />
        </svg>
    );
}
